export class User
{
    public readonly id: string;

    public readonly email: string;

    public readonly firstName?: string;

    public readonly lastName?: string;

    public readonly picture?: string;

    public constructor(
        id: string,
        email: string,
        firstName?: string,
        lastName?: string,
        picture?: string
    )
    {
        this.id = id;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.picture = picture;
    }

    public static fromJSON(ownerJSON: any): User
    {
        return new User(
            ownerJSON.id,
            ownerJSON.email,
            ownerJSON.firstName,
            ownerJSON.lastName,
            ownerJSON?.picture ?? 'assets/images/avatar_placeholder.webp'
        );
    }

    public toJSON(): Record<string, any>
    {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            picture: this.picture
        };
    }
}
